import api from '../api';

export const ChatSend = async (
  messages: Array<{ role: 'user' | 'assistant'; content: string }>,
  context: {
    textContent?: string;
    templateName?: string;
    domain?: string;
  },
  intent?: string,
): Promise<{ text: string }> => {
  const { data } = await api.post(
    '/chat/send',
    { messages, context, intent },
    { timeout: 60000 },
  );
  return data;
};
